<div *ngIf="modules.length > 0" title="SWITCH MODULE" class="fullHeight d-flex">
    <button id="moduleSwitcher" type="button" class="btn btn-sm btn-primary my-auto me-3" (click)="openMenu()">
        <em id="moduleSwitcherIcon" class="fas fa-bars text-white"></em>
    </button>
</div>
<div id="mySidenav" class="sidenav">
    <div class="d-inline-flex moduleHeadingCss">
        <img class="headerLogo" src="{{headerLogo}}" alt="Logo" width="70px">
        <h5 class="my-auto fs-14px fw-600 ms-3">CONFIG-PORTAL</h5>
    </div>
    <em title="Close" class="fas fa-2x fa-angle-double-up closebtn text-blue cursorPointer" (click)="closeMenu()"></em>
    <div class="row m-0">
        <div *ngFor="let module of modules" class="col-12 p-0 button-container">
            <div class="cards cursorPointer" [ngClass]="{'card-selected': module.moduleName === selectedModule}"
                (click)="navigate(module.type, module.routeUrl)">
                <ng-container *ngIf="module.moduleName === selectedModule">
                    <img width="30px" height="30px" *ngIf="module.iconClassWhiteColor.includes('assets/')" [src]="module.iconClassWhiteColor"
                        class="card-icon" [ngClass]="{'card-icon-selected': module.moduleName === selectedModule}">
                    <em *ngIf="!module.iconClassWhiteColor.includes('assets/')"
                        class="{{module.iconClassWhiteColor}} card-icon"
                        [ngClass]="{'card-icon-selected': module.moduleName === selectedModule}"></em>
                </ng-container>
                <ng-container *ngIf="module.moduleName != selectedModule">
                    <img width="30px" height="30px" *ngIf="module.iconClass.includes('assets/')" [src]="module.iconClass" class=" card-icon"
                        [ngClass]="{'card-icon-selected': module.moduleName === selectedModule}">
                    <em *ngIf="!module.iconClass.includes('assets/')" class="{{module.iconClass}} card-icon"
                        [ngClass]="{'card-icon-selected': module.moduleName === selectedModule}"></em>
                </ng-container>
                <em class="{{module.iconClass}} card-icon"
                    [ngClass]="{'card-icon-selected': module.moduleName === selectedModule}"></em>
                <p class="card-title my-auto" [ngClass]="{'card-title-selected': module.moduleName === selectedModule}">
                   <!-- <img [src]="module.iconClassWhiteColor" width="20px" height="20px">  -->
                   {{module.moduleName}}
                </p>
            </div>
        </div>
    </div>
</div>